(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["an-autumn-offer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('an-autumn-countdown')) {
  customElements.define('an-autumn-countdown', class extends HTMLElement {
    connectedCallback() {
      const end = Date.parse(this.dataset.endsAt);
      const value = this.querySelector('[data-countdown-value]');
      if (!Number.isFinite(end) || !value) return;
      const update = () => {
        const remaining = Math.max(0, Math.ceil((end - Date.now()) / 1000));
        if (!remaining) {
          this.closest('.an-autumn-offer').hidden = true;
          clearInterval(this.interval);
          return;
        }
        const days = Math.floor(remaining / 86400);
        const hours = Math.floor(remaining % 86400 / 3600);
        const minutes = Math.floor(remaining % 3600 / 60);
        const seconds = remaining % 60;
        const pad = number => String(number).padStart(2, '0');
        value.textContent = days + this.dataset.days + ' ' + pad(hours) + ':' + pad(minutes) + ':' + pad(seconds);
      };
      update();
      if (Date.now() < end) this.interval = setInterval(update, 1000);
    }
    disconnectedCallback() { clearInterval(this.interval); }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mobile-sticky-atc"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mobile-sticky-atc')) {
    class MobileStickyAtc extends HTMLElement {
      connectedCallback() {
        this.info = document.getElementById(this.dataset.infoId);
        this.stickyButton = this.querySelector('button[name="add"]');
        this.stickyPrice = this.querySelector('[data-sticky-price]');
        this.hidden = false;
        this.refreshTarget();
        this.sync();
        this.onScroll = () => this.classList.toggle('is-visible', Boolean(this.mainButton && this.mainButton.getBoundingClientRect().bottom < 0));
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.onScroll();
        this.stickyButton?.addEventListener('click', () => {
          const picker = this.info?.querySelector('[role="radiogroup"]') || this.info?.querySelector('variant-selects');
          if (picker) {
            picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
            picker.querySelector('[aria-checked="true"], input:checked, select')?.focus({ preventScroll: true });
          } else {
            this.mainButton?.click();
          }
        });

        if (this.info) {
          this.mutationObserver = new MutationObserver(() => {
            this.refreshTarget();
            this.sync();
          });
          this.mutationObserver.observe(this.info, { childList: true, subtree: true, characterData: true });
        }
      }

      disconnectedCallback() {
        this.intersectionObserver?.disconnect();
        this.mutationObserver?.disconnect();
        window.removeEventListener('scroll', this.onScroll);
      }

      refreshTarget() {
        const nextButton = document.getElementById(this.dataset.mainButtonId);
        if (!nextButton || nextButton === this.mainButton) return;

        this.mainButton = nextButton;
        this.intersectionObserver?.disconnect();
        this.intersectionObserver = new IntersectionObserver(([entry]) => {
          this.classList.toggle('is-visible', entry.boundingClientRect.bottom < 0);
        });
        this.intersectionObserver.observe(this.mainButton);
      }

      sync() {
        if (!this.mainButton || !this.stickyButton) return;

        this.stickyButton.disabled = this.mainButton.disabled;
        const mainLabel = this.mainButton.querySelector('span');
        const stickyLabel = this.stickyButton.querySelector('span');
        if (mainLabel && stickyLabel) {
          const label = this.info?.querySelector('variant-selects') && !this.mainButton.disabled
            ? this.stickyButton.dataset.chooseLabel
            : mainLabel.textContent;
          if (stickyLabel.textContent !== label) stickyLabel.textContent = label;
        }

        const currentPrice =
          this.info?.querySelector('.price--on-sale .price-item--sale') ||
          this.info?.querySelector('.price__regular .price-item--regular') ||
          this.info?.querySelector('.price-item--regular');
        const priceText = currentPrice?.textContent.trim();
        if (priceText && this.stickyPrice.textContent.trim() !== priceText) {
          this.stickyPrice.textContent = priceText;
        }
      }
    }

    customElements.define('mobile-sticky-atc', MobileStickyAtc);
  }
  } catch(e) { console.error(e); }
})();

})();
